/**
 * localStorage persistence for the auth session.
 * Single key: 'psp.session'
 */

const STORAGE_KEY = 'psp.session'

export interface StoredSession {
  id:           string
  bearerToken:  string
  expiration:   string
  refreshToken: string
}

export function getStoredSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as StoredSession
  } catch {
    return null
  }
}

export function setStoredSession(session: StoredSession): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
  } catch { /* noop */ }
}

export function clearStoredSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch { /* noop */ }
}
